module.exports = __webpack_public_path__ + "static/img/s35.455edc05.png";